import Button from "@/components/ui/button";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const Training = () => {
  return (
    <section className="w-full mx-auto">
      <div className="lg:w-11/12 w-11/12 3xl:w-8/12 mx-auto flex flex-col gap-10">
        {/* Section Header */}
        <div className="text-center flex flex-col items-center justify-center max-w-3xl mx-auto space-y-4">
          <h2 className="lg:text-5xl md:text-4xl sm:text-3xl text-2xl title font-extrabold text-center uppercase">
            Training & Courses
          </h2>
          <p className="text-zinc-700 md:text-lg text-sm leading-relaxed">
            Elevate your high-altitude skillset with professional mountaineering and specialized ice climbing courses led by certified IFMGA mountain guides.
          </p>
        </div>

        {/* 2 Cards Side by Side */}
        <div className="flex flex-col lg:flex-row gap-8">
      {/* Mountaineering Course Card - Left */}
      <div className="flex-1 flex flex-col justify-between border border-zinc-200 rounded-md p-6 shadow-sm hover:shadow-md transition-all duration-300 group bg-white">
        <div>
          <figure className="relative w-full h-64 sm:h-72 lg:h-80 overflow-hidden rounded-md mb-6">
            <Image
              src="/courses.webp"
              alt="mountaineering"
              fill
              sizes="(max-width: 1024px) 100vw, 50vw"
              className="object-cover group-hover:scale-105 transition-transform duration-300 brightness-95"
            />
          </figure>

          <div>
            <h2 className="uppercase font-bold title lg:text-2xl text-xl leading-tight">
              Himalayan Mountaineering Courses
            </h2>
            <p className="my-4 text-zinc-700 font-medium text-sm md:text-base leading-relaxed">
              Take your passion for adventure to new heights with our
              comprehensive mountaineering courses! Whether you're a beginner
              looking to explore the basics or an experienced climber aiming to
              sharpen your skills, we offer tailored programs to suit all levels.
            </p>
          </div>
        </div>

        <div className="pt-2">
          <Link href="/package_detail/himalayan-mountaineering-course">
            <Button>Enroll Now</Button>
          </Link>
        </div>
      </div>

      {/* Ice Climbing Course Card - Right */}
      <div className="flex-1 flex flex-col justify-between border border-zinc-200 rounded-md p-6 shadow-sm hover:shadow-md transition-all duration-300 group bg-white">
        <div>
          <figure className="relative w-full h-64 sm:h-72 lg:h-80 overflow-hidden rounded-md mb-6">
            <Image
              src="/ServiceImage/ice_climbing.webp"
              alt="ice climbing"
              fill
              sizes="(max-width: 1024px) 100vw, 50vw"
              className="object-cover group-hover:scale-105 transition-transform duration-300 brightness-95"
            />
          </figure>

          <div>
            <h2 className="uppercase font-bold title lg:text-2xl text-xl leading-tight">
              Ice Climbing Training
            </h2>
            <p className="my-4 text-zinc-700 font-medium text-sm md:text-base leading-relaxed">
              Master the art of ice climbing with our specialized training programs!
              Learn essential techniques, safety protocols, and equipment usage on
              frozen waterfalls and ice formations. Perfect for adventurers seeking
              to conquer vertical ice challenges in the Himalayas.
            </p>
          </div>
        </div>

        <div className="pt-2">
          <Link href="/package_detail/ice-climbing-course">
            <Button>Enroll Now</Button>
          </Link>
        </div>
      </div>
        </div>
      </div>
    </section>
  );
};

export default Training;
